import React from 'react';

import CollapseView from './CollapseView';

function Collapse(props) {
  return <CollapseView {...props} />;
}

export default Collapse;
